export default __webpack_public_path__ + "img/fb38451b0e7d7f00a31939b4fd7ab60a.png";